import React, { memo, useEffect, useState } from "react";
import { getExpertPaymentHistory } from "../../redux/actions";
import { useAppDispatch } from "../../redux/store/hooks";
import "./styles.scss";
import useExpertPaymentSelectors from "../../redux/selectors/expertPaymentSelectors";
import { IPaymentHistoryItem } from "../../redux/reducers";
import ExpertPaymentHistoryItem from "./ExpertPaymentHistoryItem";
import { CardContent, CircularProgress } from "@mui/material";
import { Typography } from "components/Shared/Typography";
import { DatePicker } from "components/Shared/DatePicker";
import { Button } from "components/Shared/Button";
import { Card } from "components/Shared/Card";
import { useTranslation } from "react-i18next";
import InfoIcon from "@mui/icons-material/Info";
import { useHistory } from "react-router-dom";
import RoutePaths from "routes/RoutePaths";
import { triggerAlert } from "../../redux/reducers";
import {
  translateFrontEndAlerts
} from "../../utils/translation";
import { convertDateToIsoFormat } from "../../utils/dateFormat";

const initialValues = {
  startDate: null,
  endDate: null
};

const ExpertPaymentHistory = () => {
  const { push } = useHistory();
  const [searchCriteria, setSearchCriteria] = useState<{
    startDate: null | Date;
    endDate: null | Date;
  }>(initialValues);
  const dispatch = useAppDispatch();
  const { paymentHistory, loading } = useExpertPaymentSelectors();
  const { t, i18n } = useTranslation();

  const handleChange = (name: string) => (value: Object) => {
    setSearchCriteria((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  useEffect(() => {
    dispatch(getExpertPaymentHistory({ endDate: null, startDate: null }));
  }, []);


  const generateHistoryItem = (
    paymentHistory: IPaymentHistoryItem[] | undefined
  ) => {
    if (!paymentHistory) {
      return;
    }
    return paymentHistory.map(
      (paymentHistoryItem: IPaymentHistoryItem, index: number) => {
        return (
          <ExpertPaymentHistoryItem
            index={index}
            status={paymentHistoryItem.status}
            date={paymentHistoryItem.date}
            totalAmount={paymentHistoryItem.totalAmount}
          />
        );
      }
    );
  };

  const _handleOnClick = () => {
    if (!searchCriteria.startDate || !searchCriteria.endDate) {
      dispatch(
        triggerAlert({
          type: "info",
          children: translateFrontEndAlerts(25001)
        })
      );
      return;
    }
    dispatch(
      getExpertPaymentHistory({
        startDate: convertDateToIsoFormat(searchCriteria?.startDate),
        endDate: convertDateToIsoFormat(searchCriteria.endDate)
      })
    );
  };

  return (
    <div className="container">
      <div className="payment-history">
        <div className="input-area">
          <Typography className="title">
            {t("expertRevenueManagement.lessonHistory.label.duration")}
          </Typography>
          <DatePicker
            local={i18n.language}
            disableKeyboardInputs={true}
            id="startDate"
            onChange={handleChange("startDate")}
            value={searchCriteria.startDate}
          />
          <span className="seperator">ー</span>
          <DatePicker
            local={i18n.language}
            disableKeyboardInputs={true}
            id="endDate"
            onChange={handleChange("endDate")}
            value={searchCriteria.endDate}
          />
          <Button
            id="ads"
            label={t("expertRevenueManagement.lessonHistory.label.searchBtn")}
            onClick={_handleOnClick}
          />
        </div>
        <Card>
          <CardContent className="card-content">
            <div className="th-row">
              <label>{t("expertRevenueManagement.paymentHistory.status")}</label>
            </div>
            <div className="summary-area">
              {generateHistoryItem(paymentHistory)}
            </div>
            {
              loading &&
              <div className="spinner_container">
                <CircularProgress color="success" className="spinner" size={20} />
              </div>
            }
          </CardContent>
        </Card>
        <div className="error-text" onClick={() => push(RoutePaths.bankDetails)}>
          <InfoIcon />
          {t("expertRevenueManagement.infoMsg")}
        </div>
      </div>
    </div>
  );
};
export default memo(ExpertPaymentHistory);
